var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-2",attrs:{"dark":"","color":"green"},on:{"click":function($event){$event.preventDefault();return _vm.submit($event)}}},[_vm._v(_vm._s(_vm.getSubmitLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }